import { CalendarDatasource } from "./calendar-datasource";
import { RequestHelper } from "../libs/request-helper";
import { CalendarResponseDto } from "../dtos/calendar-response-dto";
import { CalendarResponseEntryDto } from "../dtos/calendar-response-entry-dto";
import { Utility } from "../libs/utility";
declare var Hyphenator:any;

export class CalendarMenuDatasource implements CalendarDatasource {

	reload: () => void;

	calendarRendered(): void {

	}

	private lastDate: Date;
	private entries: { [id: string]: CalendarResponseEntryDto[] } = {};

	async loadMonth(year: number, month: number): Promise<boolean> {
		this.entries = {};

		var data = {
			year: year,
			month: month,
			includeLastDate: this.lastDate === undefined
		};
		const result = await RequestHelper.postJson<CalendarResponseDto>("/wp-content/themes/enfold-schauspielhaus/json/calendar.php", data);

		if(result.code != 200 || result.data == null) {
			return false;
		}

		if(result.data.lastDate) {
			this.lastDate = Utility.getUtcDateFromUnspecified(result.data.lastDate);
		}

		for(const entry of result.data.entries) {

			let date =null;
			if(entry.begin != null){
				date = Utility.getUtcDateFromUnspecified(entry.begin);
			}else{
				date = Utility.getUtcDateFromUnspecified(entry.end);
			}
			const key = Utility.getDateUtcKey(date);

			if(!this.entries.hasOwnProperty(key)) {
				this.entries[key] = [];
			}

			this.entries[key].push(entry);
		}
		//Disabled due to chrome bugs at the moment
		//Hyphenator.run();
		return true;
	}

	shouldRenderDetails = true;

	getFirstDate(): Date {
		const todayLocal = new Date();
		return new Date(Date.UTC(todayLocal.getFullYear(), todayLocal.getMonth(), todayLocal.getDate()));
	}

	getLastDate(): Date {
		return this.lastDate;
	}

	hasEvent(date: Date): boolean {
		return this.entries.hasOwnProperty(Utility.getDateUtcKey(date));
	}


	getEventDetails(dateKey: string): CalendarResponseEntryDto[] {
		if(this.entries.hasOwnProperty(dateKey)) {
			return this.entries[dateKey];
		}
		return [];
	}

	onDateClick(dateKey: string): void {

	}

	onSelectMonth(year: number, month: number): void {

	}
}
